<template>
  <section class="sectionOuterBox bgBlue" aria-label="Mobile app information">
    <div class="sectionInnerBox">
      <v-container class="container sectionContainer headlineSectionContainer">
        <v-row>
          <v-col cols="12" md="6">
            <div class="sectionHeader headlineSectionHeader">
              <h1 class="headLineText">{{ $t('mobile.headline.title') }}</h1>
              <div class="subText" style="min-height: 44px;">
                <span class="line">{{ $t('mobile.headline.subtitleLine1') }}</span>
                <span class="line">{{ $t('mobile.headline.subtitleLine2') }}</span>
              </div>
              <div>
                <div class="btnMobile btnAppStore">
                  <a href="https://apps.apple.com/us/app/planbook-com/id1502332358"
                     target="_blank"
                     rel="noopener noreferrer"
                     :aria-label="$t('mobile.headline.appStoreAriaLabel')">
                    <img src="https://cdn.planbook.com/images/mobile-app-store.png" alt="">
                  </a>
                </div>
                <div class="btnMobile">
                  <a href="https://play.google.com/store/apps/details?id=com.planbook.lessonplanner"
                     target="_blank"
                     rel="noopener noreferrer"
                     :aria-label="$t('mobile.headline.playStoreAriaLabel')">
                    <img src="https://cdn.planbook.com/images/mobile-play-store.png" alt="">
                  </a>
                </div>
              </div>
            </div>
          </v-col>
          <v-col class="headlineImageContainer" cols="12" md="6">
            <img class="headlineImage"
                 src="https://cdn.planbook.com/images/welcome-mobile-c.png"
                 alt="">
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Headline extends Vue {
}
</script>

<style lang="scss" scoped>
.btnMobile.btnAppStore {
  padding-left: 28px;
  padding-right: 28px;
}

.headlineSectionHeader .btnMobile {
  border: 1px solid #FFFFFF;
}

.btnMobile {
  position: relative;
  display: inline-block;
  padding: 8px 15px 5px 15px;
  background-color: black;
  border-radius: 8px;
  margin: 10px;
  transition: box-shadow 0.2s ease;
}

.btnMobile:focus-within {
  box-shadow: 0 0 0 2px #ffffff;
}

.btnMobile a {
  display: block;
  text-decoration: none;
  outline: none;
}

.btnMobile a>span {
  display: none;
}

.btnMobile img {
  cursor: pointer;
  height: 40px;
}

.sectionInnerBox {
  padding: 0;
}

.headlineSectionContainer {
  background-image: url('https://cdn.planbook.com/images/welcome-app-bg.jpg');
  background-size: cover;
  background-position: center;
  padding: 33px 30px;
}

.headlineImageContainer {
  position: relative;
  height: 342px;
}

@media screen and (min-width: 991px) and (max-width: 1199px) {
  .headlineImage {
    bottom: -48px;
  }
}

@media screen and (max-width: 960px) {
  .headlineImageContainer {
    height: 255px;
  }
}

@media screen and (max-width: 600px) {
  .headlineImageContainer {
    height: 100px;
  }
}
</style>
